export default __webpack_public_path__ + "static/media/timesquare_by_day.5cda32fd.jpg";